function hamburger() {
  // Toggle is-active on navigation
  const burger = document.getElementById('hamburger');
  const nav = document.getElementById('nav-container');
  const body = document.body;

  burger.addEventListener('click', () => {
    burger.classList.toggle('is-active');
    nav.classList.toggle('is-active');
    body.classList.toggle('noscroll');
    burger.setAttribute(
      'aria-expanded',
      burger.getAttribute('aria-expanded') === 'false' ? 'true' : 'false'
    );
  });
}

document.addEventListener('DOMContentLoaded', function () {
    hamburger();
}, false);